
import "@babel/polyfill";
import "mutationobserver-shim";
import "./plugins/bootstrap-vue";
import moment from 'moment';
moment.locale('de');
Vue.use(require('vue-moment'), { moment });

import Vue from "vue";
import wrap from "@vue/web-component-wrapper";
import WebComponentApp from "./WebComponentApp.vue";

Vue.config.productionTip = false;

const wrappedElement = wrap(Vue, WebComponentApp);

window.customElements.define("events-admin", wrappedElement);